import React from 'react';
import type { PasswordValidation } from '../shared';
import { PasswordInput, PasswordValidationDisplay, TextInput } from '../shared';

export interface UserFormData {
  username: string;
  password: string;
  confirmPassword: string;
  role?: 'user' | 'admin';
}

interface UserFormProps {
  formData: UserFormData;
  passwordValidation: PasswordValidation;
  onFormChange: (data: UserFormData) => void;
  onPasswordChange: (password: string) => void;
  showRole?: boolean;
  showUsername?: boolean;
  disabled?: boolean;
}

const UserForm: React.FC<UserFormProps> = ({
  formData,
  passwordValidation,
  onFormChange,
  onPasswordChange,
  showRole = false,
  showUsername = true,
  disabled = false,
}) => {
  const handleFieldChange = (field: keyof UserFormData, value: string) => {
    onFormChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      {showUsername && (
        <div>
          <TextInput
            id="username"
            label="Username"
            value={formData.username}
            onChange={(value) => handleFieldChange('username', value)}
            placeholder="Enter username"
            disabled={disabled}
            required
          />
        </div>
      )}

      <div>
        <PasswordInput
          id="password"
          label="Password"
          value={formData.password}
          onChange={onPasswordChange}
          placeholder="Enter password"
          autoComplete="new-password"
          disabled={disabled}
          required
        />
        <PasswordValidationDisplay password={formData.password} validation={passwordValidation} />
      </div>

      <div>
        <PasswordInput
          id="confirmPassword"
          label="Confirm Password"
          value={formData.confirmPassword}
          onChange={(value) => handleFieldChange('confirmPassword', value)}
          placeholder="Confirm password"
          autoComplete="new-password"
          disabled={disabled}
          required
        />
      </div>

      {showRole && (
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Role</label>
          <select
            value={formData.role || 'user'}
            onChange={(e) => handleFieldChange('role', e.target.value as 'admin' | 'user')}
            className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-black"
            disabled={disabled}
          >
            <option value="user">User</option>
            <option value="admin">Admin</option>
          </select>
        </div>
      )}
    </div>
  );
};

export default UserForm;
